<template>
    <a
        class="link text-white text-nav leading-loose"
        :key="item._uid"
        :to="item.link"
        @click="handleClick"
    >
        {{ item.label }}
    </a>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    methods: {
        handleClick() {
            const { link, anchor } = this.item;
            this.$router.push({ path: link });
            if (anchor) {
                this.$router.push({ hash: anchor });
            }
        },
    },
};
</script>

<style lang="sass" scoped>
@import ~include-media/dist/include-media
@import ~styles/base
@import ~styles/typography

.link
    cursor: pointer
    display: block
    transition: opacity var(--speed-fast) var(--motion-out), transform var(--speed-fast) var(--motion-out)

    @for $i from 1 through 4
        &:nth-child(#{$i})
            transition-delay: $i*50ms

.scrolled
    .link
        pointer-events: none
        opacity: 0
        transform: translateY(calc(var(--line-base) * -0.25))
        transition-timing-function: var(--motion-sharp), var(--motion-sharp)
</style>
